import { ReasonDialog } from "@amber/ui";
import { ROLE_LABELS, type UserRow } from "../../contracts/index";
import { accessCommands } from "../queries";
import { AFTER_ACCESS_CHANGE } from "../keys";

export function DeactivateDialog({ user, onClose }: { user: UserRow; onClose: () => void }) {
  return (
    <ReasonDialog
      title={`Deactivate ${user.display_name}?`}
      confirm="Deactivate"
      danger
      success={`${user.display_name} is deactivated`}
      onClose={onClose}
      invalidate={AFTER_ACCESS_CHANGE}
      run={(reason, csrf) => accessCommands.deactivate(user.id, { base_revision: user.revision, reason }, csrf)}
    >
      They are signed out everywhere and can&apos;t sign in again, also not through an auto-join domain. Their work
      stays as it is.
    </ReasonDialog>
  );
}

export function ReactivateDialog({ user, onClose }: { user: UserRow; onClose: () => void }) {
  return (
    <ReasonDialog
      title={`Reactivate ${user.display_name}?`}
      confirm="Reactivate"
      success={`${user.display_name} can sign in again`}
      onClose={onClose}
      invalidate={AFTER_ACCESS_CHANGE}
      run={(reason, csrf) => accessCommands.reactivate(user.id, { base_revision: user.revision, reason }, csrf)}
    >
      They can sign in again with their Google account and keep the role <b>{ROLE_LABELS[user.role]}</b>.
    </ReasonDialog>
  );
}
